
<template>
  <div>
      <div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Bank Masr Payment </a></h1>

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Payment list </div>
<div class="panal-body " >
    <div class="table table-responsive col-md-10  m-auto">



        <table  border="1"  class="tabel" width="100%">
            <thead>
                <tr class="text-uppercase jumbotron" style="text-transform:capitalize">
                    
                    <th align="center" class="text-center"><strong>Payment order</strong></th>
                    <th align="center"  class="text-center"><strong>Value</strong></th>
                </tr>
            </thead>


            <tbody class="text-center" >
                <tr>
                   
                    <td>{{ OrderDetails[0].payment_order_no }}
                    </td>
                   
                    <td>{{ OrderDetails[0].Column1 }}
                    </td>
                   
                    </tr>
                   
            </tbody>
            <tfoot></tfoot>
        </table>

  <div>
  
  </div>

    <!-- <div>order:{{ orderId }}</div> -->


    </div>
        <!-- <p class="mt-50 alert alert-warning">  Please Review your payment List Carefully then Press Next Button Bank Fess is almost 1% of total amount </p> -->
        <!-- <div class="text-center"> <b-link class=" " @click="$router.push('ProcessPayment')">

                        <button class="btn btn-primary text-center">Next</button>
                      </b-link></div> -->
            <!-- <input type="image" class="mt-50" @click="GetMerchantRefNumber" src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png" alt="Edfa3 Fawry" id="xsrrs" /> -->
    </div>
<!-- <p style="color: #000;">{{ sessionId}}</p>
<p style="color: #000;">{{ orderId}}</p> -->

     <!-- Button to trigger modal -->
     <div align="center">
     <button type="button" class="btn btn-primary" @click="openModal" v-if="!showModel">
     
      Pay Now
    </button>
    <div class="modal-body custom-scroll" id="hco-embedded" v-if="showModel" style="color: #000;">
   
            <!-- This will be filled by Mastercard Checkout API -->
          </div>

</div>
  
    
  </div>
</div>
</div>
      </div>
  </div>
  
</template>



<script>
import ApplicantService from '../../services/Applicant/Applicant.service'
import axios from 'axios';

export default {
  data() {
    return {
      OrderDetails: null,
      showModel: false,
      sessionId: null,
      orderId: null,
    }
  },
  mounted() {
    ApplicantService.GetUnpaidPaymentOrderDetails(this.currentUser.UserIDSerial).then(response => {
      this.OrderDetails = response.data;
      this.getSession(this.OrderDetails[0].Column1,this.OrderDetails[0].payment_order_no);
    }, error => {
      this.message = (error.response && error.response.data) || error.message || error.toString();
    });

    // Load Checkout JS dynamically
    const script = document.createElement('script');
    script.src = 'https://banquemisr.gateway.mastercard.com/static/checkout/checkout.min.js';
    script.async = true;
    script.onload = () => {
    console.log('Checkout script loaded');
    this.initCheckout();
    // script.setAttribute('data-beforeRedirect=Checkout.saveFormFields');
    // script.setAttribute('data-afterRedirect="Checkout.restoreFormFields"');
     script.setAttribute('data-complete', 'returnCallbackBankMisr');
    script.setAttribute('data-error', 'returnCallbackBankMisr');
    
  };
    // script.onload = this.initCheckout;
    document.head.appendChild(script);
  },

  methods: {
    async getSession(value,orderId) {
      try {
        const response = await axios.post(`https://suapplication.su.edu.eg:151/api/BankMasr_MPGS/BankSessionAsync?Value=${value}&PaymentOrderid=${ orderId}`);
        if (response.data && response.data.decodedResponse.session && response.data.decodedResponse.session.id) {
          this.sessionId = response.data.decodedResponse.session.id;
          this.orderId = response.data.OrderId;
          this.initCheckout();
        }
      } catch (error) {
        console.error('Error fetching session ID:', error);
      }
    },
    openModal() {
      this.showModel = true;
      this.$nextTick(() => {
        if (this.sessionId) {
          Checkout.showEmbeddedPage('#hco-embedded');
        }
      });
    },
    closeModal() {
      this.showModel = false;
      sessionStorage.clear(); // Clear sessionStorage on modal close
    },
    initCheckout() {
      if (this.sessionId) {
        Checkout.configure({
          session: {
            id: this.sessionId
          },
          callbacks: {
            complete: this.returnCallbackBankMisr.bind(this),
            error: this.returnCallbackBankMisr.bind(this)
          }
        });
      }
    },
    async returnCallbackBankMisr(status) {
      alert(status);
      console.log("callback", status);
      try {
        await axios.get('https://suapplication.su.edu.eg:151/api/BankMasr_MPGS/GetOrderStatus', {
          OrderId: this.orderId,
          // sessionId: this.sessionId,
          // status: status
        });
        console.log('Status sent to the database successfully');
      } catch (error) {
        console.error('Error sending status to the database:', error);
      }
    },
  },
  computed: {
    PaymentStore() {
      return this.$store.state.auth.paymentList;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    reviewApplication() {
      return this.$store.state.auth.renderReview;
    },
    currenUser() {
      return this.$store.state.auth.user;
    },
  }
}
</script>




<style>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-light th {

    font-size: 14px !important;
}
.mt-50{
    margin-top: 50px !important;
}
.m-auto{
    margin: auto !important;
}

#overlay{
  position: unset !important;
}
</style>